<template>
  <mt-popup v-model="moduleState.musicLibrary" position="bottom" class="page-module">
    <template>
      <malib-region v-bind:malibConf="{data: malib.comentData.secondData, id: thirdId}"
                    @cut="classifyCut($event, 82)"></malib-region>

      <div class="content-wrapper">
        <mt-loadmore
          ref="loadmore"
          :auto-fill=false
          :bottom-method="loadBottom"
          :bottom-all-loaded="allLoaded"
        >
          <ul>
            <template v-if="maData.length > 0">
              <li v-for="(item, $index) in maData" class="malib-list">
                <div class="row">
                  <i @click="resourceSign(item, item.name, $index)" class="music-radio"
                     :class="{'act': $index === selectedIndex}"></i>
                </div>
                <ul class="music-detail row clearfix">
                  <li class="play" :class="{'act': item.act}" @click="play(item)"></li>
                  <li class="time" v-text="getDuration(item.duration)"></li>
                  <li class="name" v-text="item.name">
                  </li>
                </ul>
              </li>
            </template>
            <template v-else>
              <li v-if="!isLoading">没有数据</li>
            </template>
          </ul>
        </mt-loadmore>
      </div>
      <malib-classify v-bind:malibConf="{data: malib.comentData.firstData, id: secondId}"
                      @cut="classifyCut($event, 83)"></malib-classify>
    </template>
    <template v-if="isLoading">
      <div class="loading">
        <mt-spinner type="double-bounce" color="#ff6600"></mt-spinner>
      </div>
    </template>

    <malib-filter v-bind:malibConf="{data: malib.comentData.thirdData, id: listId, lock: false}"
                  @cut="classifyCut($event, 81)"></malib-filter>

    <a v-if="malib.comentData.resData.length > 0 && selectedIndex !== -1" href="javascript:;" class="use-btn"
       @click="use">使用该素材</a>
  </mt-popup>
</template>

<script>
  import Vue from 'vue';
  import {mapState} from 'vuex';
  import {Toast} from 'mint-ui';
  import store from '../store/store';
  import audioPlayer from '../utils/AudioPlayer';
  import {MaType, MaLib} from '../store/MaLib';
  import malibRegion from './malib_region';
  import malibClassify from './malib_classify';
  import malibFilter from './malib_filter';
  import {GameData} from '../store/GameData';
  import {ComponentName, Methods, CdnLibrary} from '../const/common';


  export default {
    store,
    name: 'music_library',
    components: {
      'malib-region': malibRegion,
      'malib-classify': malibClassify,
      'malib-filter': malibFilter
    },
    computed: {
      ...mapState(['chapterSet', 'useRole', 'moduleState', 'MaLimit', 'openMaLibAffair'])
    },
    data() {
      return {
        bigStyle: this.initBigStyle(),
        cdnLibrary: CdnLibrary,
        malib: new MaLib(this),
        isLoading: false,
        secondId: 0,
        thirdId: 0,
        listId: 0,
        selectedIndex: -1,
        page: 1,
        maCount: 0,
        dataLoading: false,
        maData: [],
        MaID: null,
        MaType: null,
        detailLoading: false,
        allLoaded: false
      }
    },
    methods: {
      getDuration(time) {
        let min = Math.floor(time / 60), s = time - min * 60;
        min = min < 10 ? '0' + min : min;
        s = s < 10 ? '0' + s : s;

        return min + ':' + s;
      },
      loadBottom() {
        this.loadMore();
      },
      loadMore() {
        this.dataLoading = true;
        this.page++;
        this.classifyCut({id: this.MaID, type:this.MaType, paging:true});
      },
      initBigStyle() {
        return Middle.ProjectData.header.style;
      },
      resourceSign(item, name, index) {
        this.selectedIndex = index;
        this.selectItem = item;
        this.chapterSet.music = item;
        this.chapterSet.musicSrc = this.cdnLibrary.CDNRES + item.preview.substr(0, 2) + '/' + item.preview;
        this.chapterSet.musicName = name;
        Methods.checkChapterHash(84);
      },
      play(item) {
        this.maData.forEach(function (item) {
          Vue.set(item, 'act', false);
        });
        audioPlayer.toggle(this.cdnLibrary.CDNRES + item.preview.substr(0, 2) + '/' + item.preview);
        Vue.set(item, 'act', !audioPlayer.playStatus());
        Methods.checkChapterHash(85);
      },
      insertEvent(res, refresh) {
        let _bgmName = GameData.setChapterConfig({bgm: res.data.data}).bgm_name;

        GameData.AddEvent("event_change_bgm", [_bgmName]);
        if (refresh) {
          store.state.openMaLibCallBack(_bgmName);
        }
      },
      use() {
        this.detailLoading = true;
        this.malib.getGoodDetail(this.selectItem.id, function (res) {
          this.detailLoading = false;
          if (parseInt(res.status) <= 0) {
            this.errorComplete();
            return;
          }
          switch(this.openMaLibAffair) {
            case 'insert':
              this.insertEvent(res, false);
              Methods.checkChapterHash(30);
              break;
            case 'changeInsert':
              this.insertEvent(res, true);
              Methods.checkChapterHash(80);
              break;
            default:
              store.state.chapterConfig.bgm = res.data.data;
          }
          Methods.cutComponent([ComponentName.MUSIC_LIBRARY], false);
          Methods.multimediaReset();
        }, this.errorComplete, this);
        Methods.checkChapterHash(86);
      },
      errorComplete() {
        return Toast({
          message: '网络异常，请重试'
        })
      },
      classifyCut(_event, hash) {
        let id = _event.id, type = _event.type, paging = _event.paging;

        if (!paging) {
          this.selectedIndex = -1;
          this.selectItem = null;
          audioPlayer.close();
        }

        let _isLoading = false;

        this.MaID = id;
        this.MaType = type;
        this.allLoaded = false;
        if (id !== null && type !== null && !paging) {
          this.maData = [];
          this.page = 1;
        }
        if (this.maData.length <= 0) {
          _isLoading = true;
        }
        this.malib.setIdByTitleType(id, type);
        this.malib.initTypeData(MaType.AUDIO, this.page, function (data) {
          let _data = data.data[0].data;

          this.maCount = data.data[0].count;
          for (let i = 0; i < _data.length; i++) {
            Vue.set(_data[i], 'act', false);
            this.maData.push(_data[i])
          }
          this.dataLoading = false;
          if (this.page > 1) {
            this.$nextTick(function () {
              this.$refs.loadmore.onBottomLoaded();
            });
          }
          if (this.page >= Math.ceil(parseInt(this.maCount) / this.MaLimit)) {
            this.allLoaded = true;
          }
        }, this.errorComplete, this, _isLoading);
        Methods.checkChapterHash(hash);
      },
    },
    mounted() {
      this.$nextTick(function () {
        this.classifyCut({id:this.MaID, type:this.MaType, paging:false}, 88);
      });
    }
  }
</script>

<style scoped>
  @import "../style/css/malib_music.css";
</style>



// WEBPACK FOOTER //
// src/components/malib_music.vue